export default class PromotionController {
    constructor(resource) {
        this._resource = resource;
    }

    getById(promotionId){
        return this._resource(`promotion/${promotionId}`).get()
            .then(res => {
                return res.body
            }, err => {
                throw new Error(err)
            });
    }

    get() {
        return this._resource('promotion').get()
            .then(res => {
                return res.body
            }, err => {
                throw new Error(err)
            });
    }

    create(promotion) {
        return this._resource('promotion').save(promotion)
            .then(res => {
                return res.body
            }, err => {
                throw new Error(err)
            });
    }

    getByClient() {
        return this._resource('promotion/client').get()
            .then(res => {
                return res.body
            }, err => {
                throw new Error(err)
            });
    }

    getBannerByClient() {
      return this._resource('promotion/banner/client').get()
          .then(res => {
              return res.body
          }, err => {
              throw new Error(err)
          });
  }

    disable(promotionId) {
        return this._resource(`promotion/disable/${promotionId}`).update()
            .then(res => {
                return res.body
            }, err => {
                throw new Error(err)
            });
    }

    getPromotionVehicleModelsByPromotion(promotionId) {
        return this._resource(`promotionVehicleModel/${promotionId}`).get()
            .then(res => res.body)
            .catch(e => { throw e })
    }

    subscribeRecurrent(promotionId, credit_card_id, installments) {
        return this._resource(`promotion/subscribe/${promotionId}/${credit_card_id}`).save({installments})
            .then(res => res.body)
            .catch(e => { throw e })
    }

    checkActivePromotion(promotionId) {
        return this._resource(`promotion_user/user`).get()
            .then(res => res.body)
            .catch(e => { throw e })
    }

    teste(data) {
        return this._resource(`promotion/teste`).save(data)
            .then(res => res.body)
            .catch(e => { throw e })
    }

    getPromotionVehicleModelsByPromotionAndModel(promotionId, modelId) {
        return this._resource(`promotionVehicleModel`).get({ promotionId, modelId })
            .then(res => res.body)
            .catch(e => { throw e })
    }

    alterarClientesPromocao(promotionId, selectedClients){
        return this._resource(`promotion/${promotionId}`).update(selectedClients)
            .then(res => res.body)
            .catch(e => { throw e })
    }
}

